/**
 * What an invited roster row lets the trainer do about its invitation — the two acts, and the one
 * fact both of them turn on.
 *
 * `GET /customer` returns two kinds of `invited` row (`clientRow`'s `openableCustomerId` has the
 * contract). An invited roster ENTRY (R2) is a person the trainer created and already coaches
 * against; an OFFER (R12) went to an address that already had an account. `customerId` is non-null
 * on the first and null on the second, and that is the whole of what these read.
 *
 * Pure: no React, no DOM, no i18next.
 */

import type { ClientRow } from './clientRow';

function isInvitedEntry(row: ClientRow): boolean {
  return row.status === 'invited' && row.invitationId !== null && row.customerId !== null;
}

/**
 * The invitation e-mail can be sent again — mobile's `onResend`, gated on `canAssignWork`.
 *
 * `CustomerOnboardingProcessor.ResendInvitationEmailAsync` refuses unless the person the invitation
 * names is still `Invited`, which an entry is until it is answered and an offer to an existing
 * account never is. A resend on an entry whose link was already used is refused too; that answer
 * is the backend's to give, and the roster says it failed.
 */
export function canResendInvitation(row: ClientRow): boolean {
  return isInvitedEntry(row);
}

/**
 * Withdrawing this invitation deletes a roster entry — and the plan, surveys and schedule prepared
 * for it — rather than an offer alone. The confirm has to say so.
 */
export function withdrawRemovesEntry(row: ClientRow): boolean {
  return isInvitedEntry(row);
}
